import vieweditscore from "./vieweditscore";

export default vieweditscore;
